var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCustomer(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26.277,
    height: 23.3,
    viewBox: "0 0 26.277 23.3",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_831",
    "data-name": "Group 831",
    transform: "translate(-845.75 -373.75)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_829",
    "data-name": "Group 829",
    transform: "translate(846 374)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_173",
    "data-name": "Path 173",
    d: "M890.956,462.08h-2.871V459.3a1.3,1.3,0,0,0-1.3-1.3H872.992a1.3,1.3,0,0,0-1.3,1.3v2.779h-2.871A1.822,1.822,0,0,0,867,463.9v15.079a1.823,1.823,0,0,0,1.821,1.821h22.135a1.822,1.822,0,0,0,1.821-1.821V463.9a1.822,1.822,0,0,0-1.821-1.821Zm-17.7-2.519h13.272v2.519H873.253Zm-4.432,4.08h22.135a.263.263,0,0,1,.26.26v4.679h-7.888v-.7a1.3,1.3,0,0,0-1.3-1.3H877.75a1.3,1.3,0,0,0-1.3,1.3v.7h-7.888V463.9a.263.263,0,0,1,.26-.26Zm12.947,4.5v2.519H878.01v-2.519Zm9.188,11.1H868.821a.263.263,0,0,1-.26-.26V470.14h7.888v.779a1.3,1.3,0,0,0,1.3,1.3h4.278a1.3,1.3,0,0,0,1.3-1.3v-.779h7.888v8.839a.263.263,0,0,1-.26.26Zm0,0",
    transform: "translate(-867 -458)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.5
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomer);
export default __webpack_public_path__ + "static/media/customer.83b76a00.svg";
export { ForwardRef as ReactComponent };